module.exports = __webpack_public_path__ + "static/img/9.b3b1578.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/sp/9.png
// module id = jiR+
// module chunks = 0